/**
 * Aurum & Ash — Super Juice Calculator
 * Preserves all original formulas and logic from the Craft theme version.
 * Supports: lemon, lime, orange, grapefruit
 * Modes: zest weight (grams) → recipe, desired volume (mL) → recipe
 */
(function () {
  var containers = document.querySelectorAll('[id^="super-juice-"]');

  containers.forEach(function (container) {
    var citrusPills = container.querySelectorAll('[data-citrus]');
    var modeBtns = container.querySelectorAll('[data-mode]');
    var modeSlider = container.querySelector('[data-mode-slider]');
    var zestInput = container.querySelector('[data-juice-input="zest"]');
    var volumeInput = container.querySelector('[data-juice-input="volume"]');
    var zestGroup = container.querySelector('[data-input-group="zest"]');
    var volumeGroup = container.querySelector('[data-input-group="volume"]');

    var resultZest = container.querySelector('[data-result-value="zest"]');
    var resultWater = container.querySelector('[data-result-value="water"]');
    var resultCitric = container.querySelector('[data-result-value="citric"]');
    var resultMalic = container.querySelector('[data-result-value="malic"]');
    var resultSugar = container.querySelector('[data-result-value="sugar"]');
    var resultMsg = container.querySelector('[data-result-value="msg"]');

    var rowMalic = container.querySelector('[data-result="malic"]');
    var rowSugar = container.querySelector('[data-result="sugar"]');
    var rowMsg = container.querySelector('[data-result="msg"]');

    var currentCitrus = 'lemon';
    var currentMode = 'zest';

    // Identical recipe data from original calculator
    var recipes = {
      lemon: {
        water: 10,
        citric: 0.047,
        malic: 0,
        sugar: 0,
        msg: 0
      },
      lime: {
        water: 10,
        citric: 0.043,
        malic: 0.019,
        sugar: 0,
        msg: 0
      },
      orange: {
        water: 8.33334,
        citric: 0.023,
        malic: 0.002,
        sugar: 0.07,
        msg: 0
      },
      grapefruit: {
        water: 10,
        citric: 0.015,
        malic: 0.002,
        sugar: 0.07,
        msg: 0.004
      }
    };

    // Identical number formatting from original calculator
    function formatNumber(num) {
      if (num === 0) return '0';
      if (num < 0.01) return num.toFixed(3);
      if (num < 1) return num.toFixed(2);
      return num.toFixed(1);
    }

    // Identical calculation logic from original calculator
    function calculate() {
      var recipe = recipes[currentCitrus];
      var zest, water;

      if (currentMode === 'zest') {
        zest = parseFloat(zestInput.value) || 0;
        water = zest * recipe.water;
      } else {
        water = parseFloat(volumeInput.value) || 0;
        zest = water / recipe.water;
      }

      resultZest.textContent = formatNumber(zest) + ' g';
      resultWater.textContent = formatNumber(water) + ' mL';
      resultCitric.textContent = formatNumber(water * recipe.citric) + ' g';
      resultMalic.textContent = formatNumber(water * recipe.malic) + ' g';
      resultSugar.textContent = formatNumber(water * recipe.sugar) + ' g';
      resultMsg.textContent = formatNumber(water * recipe.msg) + ' g';

      // Show/hide optional ingredients based on citrus type
      toggleRow(rowMalic, recipe.malic !== 0);
      toggleRow(rowSugar, recipe.sugar !== 0);
      toggleRow(rowMsg, recipe.msg !== 0);
    }

    function toggleRow(row, show) {
      if (!row) return;
      if (show) {
        row.classList.remove('aa-juice__result-row--hidden');
      } else {
        row.classList.add('aa-juice__result-row--hidden');
      }
    }

    // Citrus pill selection
    citrusPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        citrusPills.forEach(function (p) {
          p.classList.remove('aa-juice__citrus-pill--active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('aa-juice__citrus-pill--active');
        pill.setAttribute('aria-checked', 'true');
        currentCitrus = pill.dataset.citrus;
        calculate();
      });
    });

    // Mode toggle
    function setMode(mode) {
      currentMode = mode;

      modeBtns.forEach(function (btn) {
        var isActive = btn.dataset.mode === mode;
        btn.classList.toggle('aa-juice__mode-btn--active', isActive);
        btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      // Slide indicator
      if (modeSlider) {
        if (mode === 'volume') {
          modeSlider.classList.add('aa-juice__mode-slider--right');
        } else {
          modeSlider.classList.remove('aa-juice__mode-slider--right');
        }
      }

      // Toggle input groups
      if (zestGroup && volumeGroup) {
        zestGroup.classList.toggle('aa-juice__input-group--hidden', mode !== 'zest');
        volumeGroup.classList.toggle('aa-juice__input-group--hidden', mode !== 'volume');
      }

      calculate();
    }

    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMode(btn.dataset.mode);
      });
    });

    // Input listeners
    if (zestInput) zestInput.addEventListener('input', calculate);
    if (volumeInput) volumeInput.addEventListener('input', calculate);

    // Initial calculation
    calculate();
  });
})();
